import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { addReservationCompleteHook, addStateTransitionHook, addCouponSubmissionHook } from 'checkout/actions/hooks';
import { toDecimals } from '../../helpers/currency';

class GoogleAnalytics extends Component {
    constructor(props) {
        super(props);
        this.props.addReservationCompleteHook(this.onReservationComplete);
        this.props.addStateTransitionHook(this.onStateTransition);
        this.props.addCouponSubmissionHook(this.onCouponSubmitted);
        this.state = {pageViewsSent: []};
    }

    isPageViewNew(urlToSend) {
        return !this.state.pageViewsSent.includes(urlToSend);
    }

    addToPageViewsSent(urlSent) {
        this.setState({pageViewsSent: [...this.state.pageViewsSent, urlSent]})
    }

    resetPageViewSent() {
        this.setState({pageViewsSent: []});
    }

    render() {
      return null;
    }

    onCouponSubmitted = (code) => {
      this.props.reportEvent(this.gaSendCommand(), 'event', 'coupon', 'couponSubmitted', 'Coupon Submission', code);
    }

    onReservationComplete = () => {
      let items = this.getItems();
      for(let i = 0; i < items.length; i++) {
          this.props.reportEvent(this.gaTrackerName()+'.ec:addProduct', items[i]);
          this.props.reportEvent(this.gaTrackerName()+'.ec:setAction', 'add');
      }

      if (this.props.total?.amount !== undefined) {
          let key = 'GoogleAnalytics_onReservationComplete_' + this.props.confirmationNumber;
          let sent = sessionStorage.getItem(key);
          if (sent !== '1') {
              this.props.reportEvent(this.gaTrackerName()+'.ec:setAction', 'purchase', {
                  'id': this.props.confirmationNumber,
                  'revenue': toDecimals({amount: this.props.total.amount, currency: this.props.currency}),
                  'insurance': this.props.hasInsurance ? "On" : "Off",
                  // 'coupon': 'SUMMER2013' // may want to support this once we have coupons -- can it handle multiple?
              });
              sessionStorage.setItem(key,'1');
          }
      }

      this.props.reportEvent(this.gaSendCommand(), 'click');
      this.resetPageViewSent();
    }

    getItems = () => {
        let items = [];

        for(let i = 0; i < this.props.tickets.length; i++) {
            items.push(
                {
                    'id': this.props.tickets[i].price_level_id,
                    'name': this.props.tickets[i].price_level_name,
                    'category': 'ticket',
                    'price': toDecimals({amount: this.props.tickets[i].cost.amount + this.props.tickets[i].buyer_fee.amount, currency: this.props.currency}),
                    'quantity': 1
                }
            );
        }

        for(let i = 0; i < this.props.productSales.length; i++) {
            items.push(
                {
                    'id': this.props.productSales[i].product_id,
                    'name': this.props.productSales[i].product_name,
                    'category': 'product',
                    'price': toDecimals({amount: this.props.productSales[i].cost.amount + this.props.productSales[i].buyer_fee.amount, currency: this.props.currency}),
                    'quantity': 1
                }
            );
        }

        for(let i = 0; i < this.props.bundleSales.length; i++) {
            items.push(
                {
                    'id': this.props.bundleSales[i].bundle_id,
                    'name': this.props.bundleSales[i].name,
                    'category': 'bundle',
                    'price': toDecimals({amount: this.props.bundleSales[i].cost.amount + this.props.bundleSales[i].buyer_fee.amount, currency: this.props.currency}),
                    'quantity': 1
                }
            );
        }

        return items;
    }

    onStateTransition = (page) => {
        let pageViewToSend = window.location.pathname + '/' +page;
        if(this.isPageViewNew(pageViewToSend)) {
            this.props.reportEvent(this.gaSendCommand(), 'pageview', pageViewToSend);
            this.addToPageViewsSent(pageViewToSend);
        }
    }

    gaTrackerName = () => {
        return this.props.config.name ?
            this.props.config.name :
            'client';
    }

    gaSendCommand = () => {
        // Tracker Name is required as part of the command to know
        // where to send the analytics to when multiple trackers
        // exist
        return `${this.gaTrackerName()}.send`;
    }
}

const mapStateToProps = state => {
    return {
        total: state.reservation.total_cost,
        currency: state.reservation.currency,
        confirmationNumber: state.reservation.confirmation_number,
        tickets: state.tickets.tickets,
        hasInsurance: !!state.reservation.hasInsurance,
        productSales: state.productSales.products,
        bundleSales: state.bundleSales.bundles,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        addReservationCompleteHook,
        addStateTransitionHook,
        addCouponSubmissionHook,
    }, dispatch);
}

GoogleAnalytics.propTypes = {
    config: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleAnalytics)
